import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image"
import { StaticQuery, graphql } from "gatsby"

import { Modal } from "../../Shared"

export const BoilerPhotoExamplesModal = ({ isVisible, dismissFunc }) => (
  <StaticQuery
    query={graphql`
      query BoilerPhotoExamples {
        boiler: contentfulAsset(
          contentful_id: { eq: "iFpYrYlFUxs02wLmVv5RY" }
        ) {
          fluid(maxWidth: 2000) {
            ...GatsbyContentfulFluid
          }
        }
      }
    `}
    render={(data) => (
      <Modal
        heading="Boiler photo examples"
        dismissFunc={dismissFunc}
        isVisible={isVisible}
        size="medium"
      >
        <div className="modal-body-columns-2 boiler-photo-examples-modal">
          <div className="boiler-photo-examples-modal-text">
            <h2 className="boiler-photo-examples-modal-text-heading">
              Boiler photo tips
            </h2>
            <ul>
              <li>
                <p>
                  Show us your full boiler including any connected pipes you can
                  see
                </p>
              </li>
              <li>
                <p>
                  Show us if your boiler is installed in your kitchen, and
                  airing cupboard, or somewhere else
                </p>
              </li>
              <li>
                <p>
                  (If possible) Show us where you boiler flue is located. This
                  will be either on your roof or an external wall near your
                  boiler
                </p>
              </li>
            </ul>
          </div>
          <div className="boiler-photo-examples-modal-photos">
            <Img
              fluid={data.boiler.fluid}
              alt="Boiler installation example photo"
              title="Boiler installation example photo"
            />
          </div>
        </div>
      </Modal>
    )}
  />
)

BoilerPhotoExamplesModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  dismissFunc: PropTypes.func.isRequired,
}
